:host{width:100%;display:flex;flex-direction:column;background-color:#fff}.toolbar-button:last-child:not(:first-child){margin-left:auto}
/*# sourceMappingURL=side-panel-tabs.component.css.map */
